/**
 * RelationsTab — all relationships where this table is a participant.
 */

import type { TableRelation } from "./DetailPanel";

export interface RelationsTabProps {
  relations?: TableRelation[];
}

export function RelationsTab({ relations = [] }: RelationsTabProps) {
  if (relations.length === 0) {
    return (
      <p className="text-xs text-white/50">
        No cross-table relationships detected for this table.
      </p>
    );
  }
  return (
    <div className="space-y-2">
      <p className="text-xs text-white/55">
        {relations.length} relationship{relations.length === 1 ? "" : "s"}{" "}
        involving this table.
      </p>
      <ul className="divide-y divide-white/5">
        {relations.map((r, i) => (
          <li key={i} className="py-2">
            <div className="font-mono text-[13px] text-white/85">
              <span className="text-[var(--primary)]">{r.source_column}</span>
              <span className="text-white/40"> → </span>
              {r.target_table}
              <span className="text-white/40">.</span>
              <span className="text-[var(--primary)]">{r.target_column}</span>
            </div>
            <div className="mt-0.5 flex items-center gap-3 text-[11px] text-white/50">
              <span>cardinality: {r.cardinality || "—"}</span>
              <span>confidence: {Math.round((r.confidence ?? 0) * 100)}%</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
